import Modal from './Modal'
import { withModal } from './withModal'

const ConnectedModal = withModal(Modal)

export { ConnectedModal as Modal }
